'use strict';

var _toConsumableArray = require("/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var deburr = require('lodash.deburr');

var escapeStringRegexp = require('escape-string-regexp');

var builtinReplacements = require('./replacements');

var builtinOverridableReplacements = require('./overridable-replacements');

var decamelize = function decamelize(string) {
  return string.replace(/([a-z\d])([A-Z])/g, '$1 $2').replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1 $2');
};

var doCustomReplacements = function doCustomReplacements(string, replacements) {
  var _iterator = _createForOfIteratorHelper(replacements),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];

      string = string.replace(new RegExp(escapeStringRegexp(key), 'g'), value);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return string;
};

var removeMootSeparators = function removeMootSeparators(string, separator) {
  return string.replace(new RegExp("".concat(separator, "{2,}"), 'g'), separator).replace(new RegExp("^".concat(separator, "|").concat(separator, "$"), 'g'), '');
};

var slugify = function slugify(string, options) {
  if (typeof string !== 'string') {
    throw new TypeError("Expected a string, got `".concat(typeof string, "`"));
  }

  options = _objectSpread({
    separator: '-',
    lowercase: true,
    decamelize: true,
    customReplacements: []
  }, options);
  var separator = escapeStringRegexp(options.separator);
  var customReplacements = new Map([].concat(_toConsumableArray(builtinOverridableReplacements), _toConsumableArray(options.customReplacements), _toConsumableArray(builtinReplacements)));
  string = doCustomReplacements(string, customReplacements);
  string = deburr(string);
  string = string.normalize('NFKD');

  if (options.decamelize) {
    string = decamelize(string);
  }

  var patternSlug = /[^a-zA-Z\d]+/g;

  if (options.lowercase) {
    string = string.toLowerCase();
    patternSlug = /[^a-z\d]+/g;
  }

  string = string.replace(patternSlug, separator);
  string = string.replace(/\\/g, '');
  string = removeMootSeparators(string, separator);
  return string;
};

module.exports = slugify; // TODO: Remove this for the next major release

module.exports.default = slugify;